import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { closeWindow } from "../../actions";
import { State } from "../../types";
import { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface Props {
    name: string
    title: string
    subtitle?: string
    children?: ReactNode
    preventClosing?: boolean
    size?: "sm" | "lg" | "xl",
    onClose?: () => void
    alwaysShow?: boolean
}
const AppModal: React.FC<Props> = (props) => {
    const openWindows = useSelector((store: State) => store.applicationStatus.openWindows);
    const dispatch: any = useDispatch();

    const close = () => {
        if (!props.preventClosing) {
            props.onClose && props.onClose()
            dispatch(closeWindow(props.name))
        }
    }

    return (
        <Modal show={openWindows.includes(props.name) || props.alwaysShow} onHide={close} size={props.size ?? undefined}>
            <div className="modal-content" style={{backgroundImage: "url(img/ui/bg_noise.png)"}}>
                <Modal.Header className="p-1">
                    <Modal.Title>
                        {props.title}
                        {props.subtitle ? <div className="modal-subtitle">{props.subtitle}</div> : null}
                    </Modal.Title>
                    {!props.preventClosing && <div className="close-button"><FontAwesomeIcon icon={faTimes} className="clickable p-3" onClick={close} /></div>}
                </Modal.Header>
                {props.children}
            </div>
        </Modal>
    )
}
export default AppModal